import { types } from 'features/taskPanel/store/types'
import get from 'lodash/get'
import { utils } from 'gipsy-misc'

const initialState = {
  uniqueKey: null,
  active: false,
  loading: false,
  mode: null,
  editMode: null,
  id: null,
  item: null
}

const taskPanelReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PANEL_LOADING:
      return {
        ...state,
        loading: action.payload
      }

    case types.SET_PANEL_ITEM:
      return {
        ...state,
        uniqueKey: utils.string.random(6),
        id: get(action, 'payload.id') || null,
        item: get(action, 'payload.item') || null
      }

    case types.OPEN_PANEL:
      return {
        ...state,
        uniqueKey: utils.string.random(6),
        active: true,
        loading: get(action, 'payload.loading') || false,
        mode: get(action, 'payload.mode') || 'create',
        editMode: 'standard',
        id: get(action, 'payload.id') || null,
        item: get(action, 'payload.item') || null
      }

    case types.OPEN_REQUEST_REVIEW_PANEL:
      return {
        ...state,
        active: true,
        mode: 'reviewRequest',
        item: get(action, 'payload.item') || null
      }

    case types.CLOSE_PANEL:
      return {
        ...state,
        uniqueKey: null,
        active: false,
        loading: false,
        mode: null,
        editMode: null,
        id: null,
        item: null
      }

    case types.SET_EDIT_MODE:
      return {
        ...state,
        editMode: get(action, 'payload.editMode')
      }
    default:
      break
  }
  return state
}

export default taskPanelReducer



// WEBPACK FOOTER //
// ./src/features/taskPanel/store/reducer.js